import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { supplyGroups } from '../../data/home';
import { SectionTag } from '../shared/SectionTag';
export function SupplyList() {
  return <section className="bg-ink py-20 md:py-32" aria-labelledby="supply-heading" data-id="element-77" data-mp="dv1y53csq8d">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-78" data-mp="4ews7wfalry7">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-79" data-mp="3mlkvdgqs8518">
          <div className="lg:col-span-7" data-id="element-80" data-mp="3mk9srk92p3bp">
            <SectionTag data-id="element-81" data-mp="3rke6j2iljjy8">What we supply</SectionTag>
            <h2 id="supply-heading" className="mt-5 font-display text-[44px] font-bold uppercase leading-[0.9] text-chalk sm:text-5xl md:text-7xl" data-id="element-82" data-mp="3rlz4l244dl0u">
              The Rest of Your Packaging Line
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-muted lg:col-span-5" data-id="element-83" data-mp="1bt9u8vkmatx5">
            Beyond what we make, we source the materials packers and converters order alongside it, so you deal with
            one supplier.
          </p>
        </div>

        <ul className="mt-14 grid border-l border-t border-edge sm:grid-cols-2 lg:grid-cols-3" data-id="element-84" data-mp="2v9k6hdrexehs">
          {supplyGroups.map(group => <li key={group.name} className="border-b border-r border-edge" data-id="element-85" data-mp="351zpmeeg4949">
              <Link to="/products" className="group flex h-full flex-col bg-coal" data-id="element-86" data-mp="302dbm2qsmoue">
                <div className="relative overflow-hidden" data-id="element-87" data-mp="304galc9xbsb9">
                  <img src={group.image} alt={`${group.name} supplied by Universal Packaging Industries, Umm Al Quwain`} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-88" data-mp="2cdkdbzmp84wm" />
                  <span className="absolute bottom-0 left-0 h-[6px] w-full origin-left scale-x-0 bg-flame transition-transform duration-200 ease-out-strong group-hover:scale-x-100" aria-hidden="true" data-id="element-89" data-mp="1kpvu26j8dgm" />
                </div>
                <div className="flex flex-1 flex-col p-7" data-id="element-90" data-mp="3pmjghfvpv3w">
                  <h3 className="font-display text-[32px] font-bold uppercase leading-none text-chalk" data-id="element-91" data-mp="3r7e07271e1r">{group.name}</h3>
                  <p className="mt-3 text-muted" data-id="element-92" data-mp="dnafrbt4vao6">{group.items.join(' · ')}</p>
                  <span className="mt-auto flex items-center justify-between pt-6 text-sm font-bold uppercase tracking-[0.08em] text-flame" data-id="element-93" data-mp="dl6el1mmcprl">
                    View products
                    <span className="flex h-10 w-10 items-center justify-center bg-flame text-ink transition-colors duration-150 group-hover:bg-chalk" data-id="element-94" data-mp="3h5aowuafdm3d">
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="3r1dte6sr1wth" />
                    </span>
                  </span>
                </div>
              </Link>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-96" data-mp="2ye1fel0nmxbs">
          <Link to="/products" className="inline-flex h-14 items-center gap-2 whitespace-nowrap border-2 border-flame px-8 text-sm font-bold uppercase tracking-[0.08em] text-chalk transition-colors duration-150 hover:bg-flame hover:text-ink" data-id="element-97" data-mp="2ycqb8k3arnk5">
            View All Products
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="1ggenijlvafei" />
          </Link>
        </div>
      </div>
    </section>;
}